<template>
  <div>
    <section class="tf-card">
      <div class="tf-card__head">
        <span class="tf-card__icon"><i class="fa fa-hand-pointer-o"></i></span>
        <div class="tf-card__titles">
          <h3 class="tf-card__title">Действия и скорость</h3>
          <p class="tf-card__sub">
            Как часто делают целевое действие при быстрой и медленной загрузке.
            «Упущено» — сколько действий добавилось бы, если бы медленные просмотры вели себя как быстрые
          </p>
        </div>
      </div>
      <div class="tf-card__body">
        <div v-if="!rows.length" class="an-empty">
          <i class="fa fa-hand-pointer-o"></i>
          <span>За период целевых действий не было</span>
        </div>
        <div v-else class="an-table-wrap">
          <table class="an-table">
            <thead>
            <tr>
              <th>Действие</th>
              <th class="an-num">Всего</th>
              <th class="an-num" title="Действий на просмотр">Конверсия</th>
              <th class="an-num">При быстрой загрузке</th>
              <th class="an-num">При медленной</th>
              <th class="an-num" title="На сколько чаще делают при быстрой загрузке">Разница</th>
              <th class="an-num">Упущено</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="row in rows" :key="row.goal">
              <td>
                {{ row.label }}
                <span v-if="!row.enough" class="an-cell-sub">мало данных для сравнения</span>
              </td>
              <td class="an-num">{{ formatCount(row.total) }}</td>
              <td class="an-num">{{ formatPercent(row.rate) }}</td>
              <td class="an-num">{{ formatPercent(row.byLcp.good.rate) }}</td>
              <td class="an-num">{{ formatPercent(slowRate(row)) }}</td>
              <td class="an-num">
                <span v-if="row.enough && row.lift !== null" class="an-change"
                      :class="row.lift > 0 ? 'an-change--better' : ''">
                  {{ row.lift > 0 ? '+' : '' }}{{ Math.round(row.lift * 100) }}%
                </span>
                <span v-else>—</span>
              </td>
              <td class="an-num">{{ row.enough && row.missed ? formatCount(row.missed) : '—' }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>

    <section v-if="bounceRows.length" class="tf-card">
      <div class="tf-card__head">
        <span class="tf-card__icon"><i class="fa fa-sign-out"></i></span>
        <div class="tf-card__titles">
          <h3 class="tf-card__title">Отказы и скорость загрузки</h3>
          <p class="tf-card__sub">Доля просмотров, после которых ушли, ничего не сделав</p>
        </div>
      </div>
      <div class="tf-card__body">
        <div class="an-tiles">
          <div v-for="row in bounceRows" :key="row.bucket" class="an-tile">
            <div class="an-tile__top"><span class="an-tile__title">{{ row.title }}</span></div>
            <div class="an-tile__value">{{ formatPercent(row.rate) }}</div>
            <div class="an-tile__sub">{{ formatCount(row.views) }} просмотров</div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {formatCount, formatPercent} from "@/common/rumFormat";

const BUCKETS = [
  {bucket: 'good', title: 'Быстрая загрузка'},
  {bucket: 'ni', title: 'Средняя'},
  {bucket: 'poor', title: 'Медленная'},
  {bucket: 'none', title: 'Не измерена'},
]

export default {
  name: "RumActions",
  props: {
    data: {type: Object, required: true},
  },
  computed: {
    rows() {
      return this.data.rows || []
    },
    bounceRows() {
      const byLcp = this.data.bounceByLcp || {}
      return BUCKETS
          .filter(b => byLcp[b.bucket] && byLcp[b.bucket].views)
          .map(b => ({...b, ...byLcp[b.bucket]}))
    },
  },
  methods: {
    formatCount,
    formatPercent,
    // Сайт считает «медленно» как средняя + плохая загрузка вместе — так же и здесь.
    slowRate(row) {
      const {ni, poor} = row.byLcp
      const views = ni.views + poor.views
      return views ? (ni.count + poor.count) / views : null
    },
  },
}
</script>
